import React from 'react';
import {browserHistory} from 'react-router';
import {SmallTileButton} from '@worthy-npm/clarity';
import I18n from 'lib/i18n/i18n';
import Listing from './../listing/listing';
import UserActions from 'lib/userActions';
import {
    isMobile,
    splitArrayToLines,
    CLICKED_EDIT_PHOTOS,
    LS
} from '../../helpers/ApplicationHelper';
import { PhotoSwipe } from 'react-photoswipe';
import EditIcon from '../editIcon';

const HIDDEN_CLASS = 'hidden';

class Settings extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isGalleryOpen: false,
            imagesPreloaded: false,
            gallery: []
        };
        this.isMobile = isMobile();
    }

    toggleHeader = (toShow = false) => {
        if (!this.pageHeader) {
            this.pageHeader = document.querySelector('header');
        }

        if (!this.notificationBanner) {
            this.notificationBanner = document.querySelector('[data-clarity-type=notification-banner]');
        }

        if (toShow) {
            this.pageHeader.classList.add(HIDDEN_CLASS);
            this.notificationBanner.classList.add(HIDDEN_CLASS);
        } else {
            this.pageHeader.classList.remove(HIDDEN_CLASS);
            this.notificationBanner.classList.remove(HIDDEN_CLASS);
        }
    }

    handleClose = () => {
        this.toggleHeader();
        this.setState({ isGalleryOpen: false })
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (JSON.stringify(prevProps.item.photos) !==  JSON.stringify(this.props.item.photos)) {
            // Who dared to resubmit or change item's submitted photos?
            this.setState({ imagesPreloaded: false });
            this.preloadImages(this.props.item.photos);
        }
    }

    componentDidMount() {
        if (this.props.item && this.props.item.photos && this.props.item.photos.length) {
            this.preloadImages();
        }
    }

    preloadImages = (photos) => {
        const imagesToBeDownload = photos || this.props.item.photos;

        this.gallery = imagesToBeDownload ? imagesToBeDownload.map((src, idx) => {
            const j = document.createElement('img');
            const requestedSrc = src.replace('/upload', '/upload/w_' + (window.innerWidth > 1000 ? 1000 : window.innerWidth));
            j.src = requestedSrc;
            // Reducing loading time from, thanks to Cloudinary transformations. 800px - is the most popular device height

            j.onload = (data) => {
                if (this.gallery[idx]) {
                    this.gallery[idx]['h'] = data.path ? data.path[0].height : data.target.height;
                    this.gallery[idx]['w'] = data.path ? data.path[0].width : data.target.width;
                }

                if (this.gallery.every(img => img.h && img.w)) {
                    this.setState({
                        imagesPreloaded: true,
                        gallery: this.gallery
                    })
                }
            };
            return { src: requestedSrc }
        }) : [];
    }

    openSwiper = () => {
        const { gallery, imagesPreloaded } = this.state;
        if (gallery && imagesPreloaded) {
            this.toggleHeader(true);
            this.setState({
                isGalleryOpen: true
            })
        }
    }

    toUploadPhotos = (itemId, action) => {
        LS.set(`${CLICKED_EDIT_PHOTOS}_${itemId}`, true)
        UserActions.listingPage(`${action} photos clicked`, itemId, Listing.version);
        browserHistory.push("/item/" + itemId)
    }

    render() {
        const fieldsOrder = {
            'jewelry_style_ring': 'listingPage::setting',
            'diamond_shape': 'listingPage::shape',
            'diamond_carat_weight': 'listingPage::carat',
            'diamond_color': 'listingPage::color',
            'diamond_clarity': 'listingPage::clarity',
            'brand_name': 'listingPage::brand'
        };

        const { item } = this.props;

        const {
            gallery,
            isGalleryOpen,
            imagesPreloaded
        } = this.state;

        if (!item) { return null }
        const itemPhotos = item.photos && item.photos.length ? item.photos.map(src => src.replace('/upload/', '/upload/w_130/')) : null;
        // It is an optimized request to Сloudinary. 130px is the element width (65) * 2 (for retina displays)
        const propertiesPerLine = 1
        const propertiesDividedByLines = splitArrayToLines(Object.entries(fieldsOrder)
            .map(record => {
                return {
                    title: I18n.getString(record[1]),
                    value: item.properties[record[0]]
                }
            }), propertiesPerLine);

        const galleryIsReady = gallery && gallery.length && imagesPreloaded;

        return <div className='item-settings'>
            <PhotoSwipe
                key="photoswipe"
                isOpen={ isGalleryOpen }
                items={ gallery }
                onClose={ this.handleClose }/>

                <div className={'image-desc'}>
                    {
                        (galleryIsReady && itemPhotos) ?
                        <div style={{ backgroundImage: `url(${ itemPhotos[0] })` }}
                            onClick={ () => { this.openSwiper() } }
                            className={'image-desc-inner' + (gallery.length > 1 ? ' with-gallery' : ' without-gallery') }>
                            {gallery.length > 1 ? <span className="photos-quantity">{ gallery.length }</span> : null}
                            <EditIcon item={item} click={()=>this.toUploadPhotos(item.id, 'edit')}/>
                        </div> : <div className="add-photo-container">
                                <SmallTileButton iconSize={"sm"} icon={"cameraPlus"} click={() => this.toUploadPhotos(item.id, 'add')} text={I18n.getString('listingPage::addPhoto')}/>
                        </div>
                    }
                    <span className={'desc'}>{item.desc}.</span>
                </div>
        </div>
    }
}

export default Settings;
